<h1 mat-dialog-title> {{ isNew ? 'Nouvelle modification' : 'Editer modification' }} </h1>
<div mat-dialog-content>

  <form #contractModificationForm="ngForm" class="contract-modification-form">
    <h6>
      Type: <b>{{data.modification.type}} </b>
    </h6>
    @if (isCarSpecific) {
      <h6>
        Véhicule: <b>{{currentCar.make}} {{currentCar.model}} {{currentCar.year}} </b>
        <br />
        <br />
      </h6>
    }

    @if (!isCarSpecific) {
      <mat-form-field>
        <mat-label>Véhicules</mat-label>
        <mat-select multiple required name="type" [(ngModel)]="data.cars">
          @for (car of cars; track car) {
            <mat-option [value]="car.carId" >{{car.make}} {{car.model}} {{car.year}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (!isCarSpecific) {
      <mat-form-field>
        <mat-label>Services inclus</mat-label>
        <mat-select multiple required name="businessLines" [(ngModel)]="data.modification.businessLines">
          @for (serv of contractBusinessLines; track serv) {
            <mat-option [value]="serv.code" >{{serv.desc}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field >
      <mat-label >Notes</mat-label>
      <textarea required matInput type="text"  name ="notes" placeholder=""  [(ngModel)]="data.modification.notes" ></textarea>
    </mat-form-field>
    <!--
    <mat-form-field >
      <mat-label>Date Activité </mat-label>
      <input matInput [matDatepicker]="picker" name="contractDate" [(ngModel)]="data.scheduledDate">
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field> -->

  </form>
</div>

<div mat-dialog-actions>
  <button class="simple-button" mat-button [mat-dialog-close]="">Annuler</button>
  <button class="simple-button" [disabled] = !contractModificationForm.valid mat-button [mat-dialog-close]="data" > Soumettre </button>
</div>